<div class="user-groups-container">
  <button (click)="openCreate()" class="btn btn-primary-outline add-button">Add User Group</button>
  <h2>Permissions
    @if (selectedStore()) {
      <a routerLink="/stores/{{selectedStore().slug}}" class="btn btn-light btn-sm">
        < Back to {{ selectedStore().name }}
      </a>
    }
  </h2>
  <form (ngSubmit)="onSubmit()" #f="ngForm">
    <table class="table table-bordered">
      <thead>
      <tr>
        <th></th>
        <th></th>
        <th>See All Stores</th>
        <th>See Specific Stores</th>
        <th>See Users</th>
        <th>Manage User Access</th>
        <th>Manage User Store Access</th>
        <th>Predictions</th>
        <th>Rotas</th>
        <th>Regenerate Rotas</th>
        <th>Employee Page</th>
        <th colspan="4">Store Page</th>
        <th></th>
      </tr>
      <tr>
        <th>Role</th>
        <th>Google Group</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th class="fw-normal">Trading Times</th>
        <th class="fw-normal">Min. No. Employees</th>
        <th class="fw-normal">Banking Collection</th>
        <th class="fw-normal">Store Closure Days</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        @for (userGroup of userGroups(); track userGroup; let i = $index) {
          <tr>
            <td class="text-nowrap">{{ userGroup.description }}</td>
            <td class="text-nowrap">{{ userGroup.email }}</td>
            <td>
              <input type="checkbox"
                     name="seeAllStores-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_ALL_STORES)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_ALL_STORES)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeSpecificStores-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_SPECIFIC_STORES)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_SPECIFIC_STORES)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeUsers-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_USERS)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_USERS)">
            </td>
            <td>
              <input type="checkbox"
                     name="manageUserAccess-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.MANAGE_USER_ACCESS)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.MANAGE_USER_ACCESS)">
            </td>
            <td>
              <input type="checkbox"
                     name="manageUserStoreAccess-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.MANAGE_USER_STORE_ACCESS)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.MANAGE_USER_STORE_ACCESS)">
            </td>
            <td>
              <input type="checkbox"
                     name="seePredictions-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_PREDICTIONS)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_PREDICTIONS)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeRotas-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_ROTAS)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_ROTAS)">
            </td>
            <td>
              <input type="checkbox"
                     name="regenerateRotas-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.REGENERATE_ROTAS)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.REGENERATE_ROTAS)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeEmployees-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_EMPLOYEES)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_EMPLOYEES)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeTradingTimes-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_TRADING_TIMES)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_TRADING_TIMES)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeStoreRequirements-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_STORE_REQUIREMENTS)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_STORE_REQUIREMENTS)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeStoreBanking-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_STORE_BANKING)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_STORE_BANKING)">
            </td>
            <td>
              <input type="checkbox"
                     name="seeStoreClosed-{{i}}"
                     [disabled]="isDisabled(userGroup)"
                     [ngModel]="hasAccess(userGroup, UserRole.SEE_STORE_CLOSED)"
                     (ngModelChange)="toggleAccess(userGroup, UserRole.SEE_STORE_CLOSED)">
            </td>
            <td>
              <i (click)="startEditing(userGroup)" class="fa fa-sm fa-edit pointer d-inline me-2"
                 [ngClass]="{'light-color': editableGroup() && editableGroup()!.email !== userGroup.email}"></i>
              <i (click)="openDelete(userGroup)" class="fa fa-sm fa-trash pointer d-inline"
                 [ngClass]="{'light-color': editableGroup() && editableGroup()!.email !== userGroup.email}"></i>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (editableGroup()) {
      <button class="btn btn-primary-outline btn-form me-2 close-button" type="button"
              (click)="stopEditing()">Cancel
      </button>
    }
    @if (editableGroup()) {
      <button class="btn btn-primary btn-form save-button" type="submit"
              [disabled]="!f.valid || loading()">Save
      </button>
    }
  </form>
</div>